import React from 'react';
import { Outlet } from 'react-router-dom';
import UISideBar from '@/components/shared/UISideBar/UISideBar';
import TopBar from '@/components/shared/TopBar/TopBar';
import MainContent from '@/components/shared/MainContent/MainContent';
import './TenantLayout.scss';
import { useScrollToAnchor } from '@/hooks/useScrollToAnchor';

const TenantLayout: React.FC = () => {
  useScrollToAnchor();
  return (
    <div className="tenant-layout">
      <UISideBar />
      <div className="tenant-layout__main">
        <TopBar />
        <MainContent>
          <Outlet />
        </MainContent>
      </div>
    </div>
  );
};

export default TenantLayout;